// extracted by mini-css-extract-plugin
module.exports = {"app":"src-app-app-d6234263","contentContainer":"src-app-contentContainer-fba7e522"};